export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  const units = ['KB', 'MB', 'GB']
  let value = bytes / 1024
  let unitIndex = 0
  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024
    unitIndex += 1
  }
  return `${value.toFixed(1)} ${units[unitIndex]}`
}

export function formatDate(isoDate: string | null): string {
  if (!isoDate) return '—'
  return new Intl.DateTimeFormat('en-NZ').format(new Date(isoDate))
}

export function getDocumentType(filename: string): string {
  const ext = filename.split('.').pop()
  return ext ? ext.toLowerCase() : ''
}

// Default title for a newly-added file — filename without its extension.
export function titleFromFilename(filename: string): string {
  const lastDot = filename.lastIndexOf('.')
  return lastDot > 0 ? filename.slice(0, lastDot) : filename
}

const MB = 1024 * 1024

export function fileSizeBandToRange(band: string): { sizeMin?: number; sizeMax?: number } {
  switch (band) {
    case 'under1mb':
      return { sizeMax: MB - 1 }
    case '1to10mb':
      return { sizeMin: MB, sizeMax: 10 * MB - 1 }
    case '10to100mb':
      return { sizeMin: 10 * MB, sizeMax: 100 * MB - 1 }
    case 'over100mb':
      return { sizeMin: 100 * MB }
    default:
      return {}
  }
}
